import {NgModule} from '@angular/core'
import {ProDirectoryPageComponent} from './pro-directory-page.component'
import {AsyncPipe, NgForOf, NgIf} from '@angular/common'
import {ProDirectoryPageRoutingModule} from './pro-directory-page-routing.module'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'
import {SortingModule} from '../../../craft/sorting/sorting.module'
import {TranslocoModule} from '@ngneat/transloco'
import {HolyGrailGridModule} from '../../../craft/holy-grail-grid/holy-grail-grid.module'
import {IndustriesAndOfferingsComponent} from './industries-and-offerings/industries-and-offerings.component'
import {IndustriesAndOfferingsSkeletonComponent} from './industries-and-offerings/industries-and-offerings-skeleton.component'
import {ListElementComponent} from '../../../craft/list-element/list-element.component'
import {SidenavModule} from '../../../craft/sidenav/sidenav.module'
import {ChipComponent} from '../../../craft/chip/chip.component'
import {SidenavOfferingsComponent} from './sidenav-offerings/sidenav-offerings.component'
import {SidenavIndustriesComponent} from './sidenav-industries/sidenav-industries.component'
import {SidenavDirectLinksComponent} from './sidenav-direct-links/sidenav-direct-links.component'
import {StickyBottomNavigationModule} from '../../../shared/components/sticky-bottom-navigation/sticky-bottom-navigation.module'
import {KnowledgeSectionComponent} from '../../../shared/components/content/knowledge-section/knowledge-section.component'
import {HowItWorksSectionComponent} from '../../../shared/components/content/how-it-works-section/how-it-works-section.component'
import {InspirationSectionComponent} from '../../../shared/components/content/inspiration-section/inspiration-section.component'
import {PromotionalBannerSectionComponent} from '../../../shared/components/content/promotional-banner-section/promotional-banner-section.component'
import {ReviewsSectionComponent} from '../../../shared/components/content/reviews-section/reviews-section.component'
import {ContentSectionComponent} from '../../../craft/content-section/content-section.component'
import {LeadSignupBannerComponent} from '../../../shared/components/content/lead-signup-section/lead-signup-banner.component'
import {HolyGrailStickyWrapperComponent} from '../../../craft/holy-grail-grid/holy-grail-grid-col-left/holy-grail-sticky-wrapper.component'

@NgModule({
  declarations: [
    ProDirectoryPageComponent,
    IndustriesAndOfferingsComponent,
    SidenavIndustriesComponent,
    SidenavOfferingsComponent,
    SidenavDirectLinksComponent,
  ],
  imports: [
    NgIf,
    AsyncPipe,
    ContentSectionComponent,
    NgForOf,
    ProDirectoryPageRoutingModule,
    FontAwesomeModule,
    SortingModule,
    TranslocoModule,
    HolyGrailGridModule,
    IndustriesAndOfferingsSkeletonComponent,
    ListElementComponent,
    SidenavModule,
    ChipComponent,
    StickyBottomNavigationModule,
    ReviewsSectionComponent,
    KnowledgeSectionComponent,
    PromotionalBannerSectionComponent,
    HowItWorksSectionComponent,
    InspirationSectionComponent,
    LeadSignupBannerComponent,
    HolyGrailStickyWrapperComponent,
  ],
})
export default class ProDirectoryPageModule {}
